import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthSessionService } from 'core/services/auth-session.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthSessionService);

  if (auth.isAuthenticated()) {
    return true;
  }

  const intendedPath = state.url.startsWith('/auth/callback') ? '/' : state.url;
  auth.startOneAuthLogin(intendedPath);
  return false;
};

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthSessionService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/']);
};
